<template>
  <div class="points-page-actions">
    <div class="actions-desktop">
      <md-button :class="[{ 'selected-option': currentOption === 'history' }]" @click="action('history')">
          <md-icon class="points-icon">history</md-icon>
          <span class="content-points">History</span>
      </md-button>
      <md-button :class="[{ 'selected-option': currentOption === 'earned' }]" @click="action('earned')">
          <md-icon class="points-icon">control_point</md-icon>
          <span class="content-points">Earned</span>
      </md-button>
      <md-button :class="[{ 'selected-option': currentOption === 'spent'}]" @click="action('spent')">
          <md-icon class="points-icon">paid</md-icon>
          <span class="content-points">Spent</span>
      </md-button>

      <md-button :class="[{ 'selected-option': currentOption === 'send' }]" @click="action('send')">
        <div class="send-points-align">
          <md-icon class="points-icon">sync_alt</md-icon>
          <div class="text-align">
            <span class="content-points">Send</span>
            <span class="content-points">points</span>
          </div>
        </div>
      </md-button>

    </div>

    <div class="actions-mobile">
      <div class="md-layout">
        <div class="md-layout-item" :class="[{ 'selected-option': currentOption === 'history' }]">
          <md-button @click="action('history')">
            <span class="content-points">History</span>
          </md-button>
        </div>
        <div class="md-layout-item" :class="[{ 'selected-option': currentOption === 'earned' }]">
          <md-button @click="action('earned')">
            <span class="content-points">Earned</span>
          </md-button>
        </div>
        <div class="md-layout-item" :class="[{ 'selected-option': currentOption === 'spent' }]">
          <md-button @click="action('spent')">
            <span class="content-points">Spent</span>
          </md-button>
        </div>
        <div class="md-layout-item" :class="[{ 'selected-option': currentOption === 'send' }]">
          <md-button @click="action('send')">
            <span class="content-points">Send</span>
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PointsPageActions",
  data() {
    return {
      currentOption: "history",
    };
  },
  methods: {
    action(option) {
      this.$emit(option);
      this.currentOption = option;
    },
  },
  created() {
    this.currentOption =localStorage.getItem("pointsSection");
  },
};
</script>

<style lang="scss" scoped>
.content-points {
  color: $dark !important;
  font-size: 12px;
}
.points-page-actions {
  margin-top: 1rem;
}
.actions-desktop {
  display: flex;
  flex-direction: column;
}
.points-page-actions .actions-desktop button {
  margin-left: 1em;
  margin-bottom: 0;
  margin-top: -1px;
  width: 120px;
  height: 56px;
}
.points-page-actions .actions-desktop span {
  margin-left: 0.75rem;
}
.points-page-actions .actions-desktop .points-icon {
  color: $dark;
  margin-left: 0;
}
.text-align {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.send-points-align {
  display: flex;
  align-items: center;
}

.md-layout-item {
  width: 25%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.md-button {
  min-width: 90%
}

@media (max-width: 960px) {
  .actions-desktop {
    display: none;
  }
  .actions-mobile {
    background: #f4f4f4;
  }
  .points-page-actions {
    margin-top: -1rem;
  }
}
@media (min-width: 961px) {
  .actions-mobile {
    display: none;
  }

  .md-button {
    min-width: 45%
  }
}
</style>

<style lang="scss">
.points-page-actions .actions-desktop .md-ripple {
  border-left: 2px solid;
  justify-content: flex-start !important;
  color: rgba(0, 0, 0, 0.54);
}

.selected-option .md-ripple,
.selected-option .points-icon {
  color: $primary !important;

  .content-points {
    color: $primary !important;
  }
}

.actions-mobile {
  text-align: center;
}

.points-page-actions .actions-mobile .selected-option {
  border-bottom: 2px solid $primary !important;
}
</style>
